var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticStyle: { float: "left" } }, [
      _c("h1", [_vm._v(_vm._s(_vm.title))])
    ]),
    _vm._v(" "),
    _c(
      "div",
      [
        _c(
          "el-form",
          {
            ref: "ruleForm",
            staticClass: "demo-ruleForm",
            attrs: {
              model: _vm.ruleForm,
              rules: _vm.rules,
              "label-width": "100px"
            }
          },
          [
            _c("table", [
              _c("tr", [
                _c(
                  "td",
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.translateWords.ProductName,
                          prop: "ProductName"
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: { disabled: true },
                          model: {
                            value: _vm.ruleForm.ProductName,
                            callback: function($$v) {
                              _vm.$set(_vm.ruleForm, "ProductName", $$v)
                            },
                            expression: "ruleForm.ProductName"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("tr", [
                _c(
                  "td",
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.translateWords.ProductCode,
                          prop: "ProductCode"
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: { disabled: true },
                          model: {
                            value: _vm.ruleForm.ProductCode,
                            callback: function($$v) {
                              _vm.$set(_vm.ruleForm, "ProductCode", $$v)
                            },
                            expression: "ruleForm.ProductCode"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("tr", [
                _c(
                  "td",
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.translateWords.SumStorage,
                          prop: "SumStorage"
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: { placeholder: _vm.translateWords.inputNum },
                          model: {
                            value: _vm.ruleForm.SumStorage,
                            callback: function($$v) {
                              _vm.$set(_vm.ruleForm, "SumStorage", _vm._n($$v))
                            },
                            expression: "ruleForm.SumStorage"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "el-form-item",
              { staticStyle: { float: "left" } },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.submitForm("ruleForm")
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.translateWords.save))]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-19498bc9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19498bc9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RK.vue
// module id = null
// module chunks = 